import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=72fa479d&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72fa479d')) {
      api.createRecord('72fa479d', component.options)
    } else {
      api.reload('72fa479d', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=72fa479d&", function () {
      api.rerender('72fa479d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8nsx3mkVPnagG/JS/comp/openstreetmap.vue"
export default component.exports